// Returns:
// - true  → very likely Wi-Fi
// - false → not Wi-Fi / can't tell but looks like non-Wi-Fi
// - null  → browser doesn't support Network Information API
export function isWifiConnection() {
  if (typeof navigator === "undefined") return null;

  const connection =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;

  if (!connection) return null;

  const { type, effectiveType, saveData } = connection;

  // If browser gives us an explicit type, trust it
  if (type === "wifi") return true;
  if (type && type !== "wifi") return false;

  // Fallback "best guess" based on effectiveType
  if (!type && effectiveType === "4g" && !saveData) {
    // Could be Wi-Fi or good mobile; this is just a guess
    return true;
  }

  return false;
}